module.exports = __webpack_public_path__ + "images/emoji/ok_woman.b58ce5a3525925c57557.png";